import React from 'react';

import { Document as StyledDocument } from './Document.styles.js';

import Loading from '../../components/Loading';

function Document({
	loading,
	document,
	onClickSignatureBox
}) {
	if (loading || !document) {
		return <Loading />
	}

	return (
		<StyledDocument className="doca">
			<StyledDocument.Card className="doca-w-full doca-p-8">
				<div className="doca-mb-8">
					<StyledDocument.HeaderTitle>
						Assinatura
					</StyledDocument.HeaderTitle>
					<StyledDocument.HeaderSubtitle>
						<strong>{document?.company?.name}</strong> enviou o seguinte documento para você assinar:
					</StyledDocument.HeaderSubtitle>
				</div>

				<StyledDocument.TextContainer className="doca-mb-6">
					<StyledDocument.TextContent className="doca-p-4 doca-m-0"
						dangerouslySetInnerHTML={{ __html: document?.text }}
					/>
				</StyledDocument.TextContainer>

				<StyledDocument.SignatureBox
					className="doca-flex doca-justify-center doca-items-center doca-cursor-pointer doca-p-2"
					hasSignature={!!document?.signature_url}
					onClick={onClickSignatureBox}
				>
					{document?.signature_url ? (
						<StyledDocument.SignatureBoxImage src={document.signature_url} alt="Assinatura" />
					) : (
						<StyledDocument.SignatureBoxPlaceholder>
							Clique aqui para assinar
						</StyledDocument.SignatureBoxPlaceholder>
					)}
				</StyledDocument.SignatureBox>
			</StyledDocument.Card>
		</StyledDocument>
	);
}

export default Document;
